import { z } from 'zod';

export type PerfilDoGrupo = 'ESCALONADO' | 'UNIFORME';
export type TipoDePerfil = 'COLABORADORES' | 'SOCIOS' | 'COLABORADORES_E_SOCIOS';

const positiveNumber = (label: string) =>
  z.coerce
    .number()
    .positive(`${label} deve ser maior que zero`);

/** Capital min/max is validated at runtime via Morte catalog limits in the step component. */
const individualCapitalNumber = (label: string) => positiveNumber(label);

export const StepDadosDoRiscoEscalonadoSchema = z.object({
  perfilDoGrupo: z.literal('ESCALONADO'),
  sdQuantidadeDeVidas: positiveNumber('Quantidade de vidas (Sócios/Diretores)'),
  sdCapitalIndividual: individualCapitalNumber(
    'Capital individual (Sócios/Diretores)'
  ),
  colQuantidadeDeVidas: positiveNumber('Quantidade de vidas (Colaboradores)'),
  colCapitalIndividual: individualCapitalNumber(
    'Capital individual (Colaboradores)'
  ),
});

export const StepDadosDoRiscoUniformeSchema = z.object({
  perfilDoGrupo: z.literal('UNIFORME'),
  tipoDePerfil: z.enum(['COLABORADORES', 'SOCIOS', 'COLABORADORES_E_SOCIOS']),
  uniQuantidadeDeVidas: positiveNumber('Quantidade de vidas'),
  uniCapitalIndividual: individualCapitalNumber('Capital individual'),
});

export const StepDadosDoRiscoSchema = z.discriminatedUnion('perfilDoGrupo', [
  StepDadosDoRiscoEscalonadoSchema,
  StepDadosDoRiscoUniformeSchema,
]);

export type StepDadosDoRiscoValues = z.infer<typeof StepDadosDoRiscoSchema>;
